import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import {
  Container,
  Grid,
  InputAdornment,
  useTheme,
  Box,
  IconButton,
} from "@mui/material";
import { useAuth } from "../../utility/auth";
import MastersController from "../../controller/MastersController";
import TenantController from "../../controller/TenantController";
import CustomizedSnackbars from "../../components/Alert";
import "../../css/style.css";
import { tokens } from "../../theme";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ExceptionHandlerController from "../../controller/ErrorLogsController";
const numberRegEx = /^[0-9\b]+$/;
const INITIAL_FORM_STATE = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
  pincode: "",
  mobile: "",
};

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Name is required"),
  email: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .email("Invalid Email Id")
    .required("Email Id is required"),
  password: Yup.string()
    .trim("No white space allowed")
    .min(8, "Password must be at least 8 characters long")
    .strict(true)
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("confirmPassword"), null],
      "New password and confirm password must match"
    )
    .trim("No white space allowed")
    .min(8, "Password must be at least 8 characters long")
    .strict(true)
    .required("Confirm-Password is required"),
  pincode: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Pin is required"),
  mobile: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Mobile is required"),
});
const mastersController = new MastersController();
const exceptionHandlerController = new ExceptionHandlerController();
const tenantController = new TenantController();

const CreateTenants = () => {
  const [togglePasswordOld, setTogglePasswordOld] = useState(true);
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const { token } = user;
  const [numberMinMax, setNumberMinMax] = useState({ pincode: "", mobile: "" });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [pincodeData, setPincodeData] = useState({ state: "", city: "" });

  const getLocation = (pincode) => {
    mastersController.GetLocation({ pincode }).then((result) => {
      if (result?.status === 200) {
        const fetchedLocation = result?.data?.body?.pincode;
        setPincodeData({
          state: fetchedLocation?.state,
          city: fetchedLocation?.city,
        });
      } else {
        setPincodeData({});
        showAlert("error", "Invalid Pincode. Please Re-enter Pincode.");
      }
    });
  };

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify?.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const submitValues = (dataValue) => {
    dataValue.state = pincodeData.state;
    dataValue.city = pincodeData.city;
    let caughtError;
    try {
      tenantController
        .Create(dataValue, token)
        .then((response) => {
          if (response?.status === 201) {
            showAlert("success", response?.data?.message);
          } else showAlert("error", response?.response?.data?.message);
        })
        .catch((error) => showAlert("error", "Oops something went wrong."));
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "Create Tenant submitValues method" };
      exceptionHandlerController.HandleException(logError);
    }
  };
  return (
    <div className="main-content">
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Home</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Create Tenant</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Formik
                  enableReinitialize
                  initialValues={INITIAL_FORM_STATE}
                  validationSchema={FORM_VALIDATION}
                  onSubmit={(values) => submitValues(values)}
                >
                  {({
                    setFieldValue,
                    handleChange,
                    handleBlur,
                    setFieldTouched,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="name"
                          autoFocus
                          label="Name"
                          type="string"
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="email"
                          label="Email Id"
                          type="string"
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="mobile"
                          label="Mobile"
                          type="string"
                          inputProps={{ maxLength: 10 }}
                          onBlur={(e) => {
                            setFieldTouched("mobile", true, true);
                            handleBlur(e);
                          }}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (numberRegEx.test(value) || value === "") {
                              setNumberMinMax((prev) => ({
                                ...prev,
                                mobile: value,
                              }));
                              setFieldValue("mobile", value);
                              setFieldTouched("mobile", true, true);
                            }
                            handleChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="password"
                          type={togglePasswordOld ? "password" : "string"}
                          label="Password"
                          inputProps={{ maxLength: 20 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() =>
                                    setTogglePasswordOld((toggle) => !toggle)
                                  }
                                >
                                  {togglePasswordOld ? (
                                    <VisibilityIcon />
                                  ) : (
                                    <VisibilityOffIcon />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="confirmPassword"
                          type={"password"}
                          label="Confirm Password"
                          inputProps={{ maxLength: 20 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="pincode"
                          label="Pin Code"
                          type={"string"}
                          onBlur={(e) => {
                            setFieldTouched("pincode", true, true);
                            const { value } = e.target;
                            if (value?.length === 6) {
                              getLocation(Number(value));
                            }
                            handleBlur(e);
                          }}
                          inputProps={{ maxLength: 6 }}
                          value={numberMinMax.pincode || ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (numberRegEx.test(value) || value === "") {
                              setNumberMinMax((prev) => ({
                                ...prev,
                                pincode: value,
                              }));
                              setFieldValue("pincode", value);
                              setFieldTouched("pincode", true, true);
                            }
                            handleChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="city"
                          label="City"
                          type="string"
                          value={pincodeData?.city}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="state"
                          label="State"
                          type="string"
                          value={pincodeData?.state}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid item xs={4} md={2} className="marginAuto">
                          <Controls.Button>Submit</Controls.Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
                {alert?.counter > 0 && (
                  <CustomizedSnackbars
                    status={alert?.counter}
                    msg={alert?.msg}
                    type={alert?.type}
                  />
                )}
              </div>
            </Container>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CreateTenants;
